export const navigateToScreen = (navigate: any, isLogin: boolean) => {
  navigate('/verify-login', {
    state: { isLogin: isLogin },
  });
};
